<div class="globalContainer">
  <!-- <app-header *ngIf="showHeader" [expanded]="headerExpanded" [ngClass]="{'header-expanded': headerExpanded }"></app-header> -->
  <app-header *ngIf="showHeader && translationsLoaded"></app-header>
  <app-breadcrumb *ngIf="showBreadcrumb && translationsLoaded" [view]="view" [path]="path"></app-breadcrumb>
  <div *ngIf="translationsLoaded" class="viewContainer"
    [ngClass]="{'content-expanded': !headerExpanded && !showHeader, 'collapsed': headerExpanded }">
    <router-outlet />
    <app-footer *ngIf="showFooter"></app-footer>  
  </div>
</div>
